import { render, staticRenderFns } from "./CouponForBundleCreateAndUpdateFormItems.vue?vue&type=template&id=a8c668c6&"
import script from "./CouponForBundleCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./CouponForBundleCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8c668c6')) {
      api.createRecord('a8c668c6', component.options)
    } else {
      api.reload('a8c668c6', component.options)
    }
    module.hot.accept("./CouponForBundleCreateAndUpdateFormItems.vue?vue&type=template&id=a8c668c6&", function () {
      api.rerender('a8c668c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CouponForBundleCreateAndUpdateFormItems.vue"
export default component.exports